import { get } from 'lodash';

export const getPrice = (serviceId, subscriptionsOptions) => {
  const service = subscriptionsOptions.find(option => option.id === serviceId);
  return service.price;
};

export const getVoucher = (serviceId, subscriptionSelected) => {
  const service = subscriptionSelected.find(option => option.id === serviceId);
  return service.voucherCode;
};

export const getServiceProperty = serviceProperty => (serviceId, subscriptionsOptions) => {
  const service = subscriptionsOptions.find(option => option.id === serviceId);
  return get(service, serviceProperty, null);
};

export const parseMPPDate = (date) => {
  const pattern = /Date\((.+)\)/;
  const [, parsedPaymentDate] = pattern.exec(date);

  return new Date(Number.parseInt(parsedPaymentDate, 10));
};
